import { sessionManagement } from '@codametrix/ui-common';

const { activityMonitor } = sessionManagement;

/** Session timer latch only — does not imply recent local input for heartbeat. */
export const setIsActive = (isActive: boolean) => {
  activityMonitor.isActive = isActive;
};

/** Local user input (mousedown/keypress) — session latch plus heartbeat sliding window. */
export const recordActivity = () => {
  activityMonitor.recordActivity();
};
